import React from 'react'
import { Switch, Route, Link } from 'react-router-dom'

import Breadcrumbs from '@/Layout/Breadcrumbs'
import PageTitle from '@/Layout/PageTitle'

import CoinsIndex from '@/pages/Coins/CoinsIndex'

function breadCrumbs() {
  // const location = useLocation()
  // const activePath = location.pathname
  // const [submission] = useGlobalState('submission')
  // will need this ^ when adding show/edit func, see creditscontainer
  const crumbs = [
    { to: '/coins', name: 'Coins' }
  ]
  return crumbs
}

function pageTitle() {
  // const location = useLocation()
  // const activePath = location.pathname
  // const [currentUser] = useGlobalState('currentUser')
  // const { id } = useParams()
  // const [submission] = useGlobalState('submission')
  // will need this ^ when adding show/edit func, see creditscontainer

  const titleInfo = {
    title: 'Coins',
    buttons: []
  }

  return titleInfo
}

export default function CoinsContainer(props) {
  const crumbs = breadCrumbs()
  const titleInfo = pageTitle()

  return <>
    <Breadcrumbs>
      { crumbs.map((crumb, index) => (
        <Link key={`${index}${crumb.name}`} to={crumb.to} className="text-xs sm:text-sm text-gray-500 hover:text-gray-700 dark:text-gray-100">
          {crumb.name}
        </Link>
      ))}
    </Breadcrumbs>
    <PageTitle pagetitle={titleInfo.title}>
      {titleInfo.buttons}
    </PageTitle>
    <Switch>
      <Route {...props} exact path={['/coins']}>
        <CoinsIndex />
      </Route>
    </Switch>
  </>
}
